export const getKeycloakAuthUrl = () => {
  const currentUrl = window._env_.KEYCLOAK_BASE_URL,
    realm = `realms/${window._env_.KEYCLOAK_REALM}`,
    clientId = `client_id=${window._env_.KEYCLOAK_CLIENT_ID}`,
    redirectUri = `redirect_uri=${window.location.origin}`,
    responseType = "response_type=code";

  return `${currentUrl}/${realm}/protocol/openid-connect/auth?${responseType}&${clientId}&${redirectUri}`;
};
